// extracted by mini-css-extract-plugin
export default {"wrapper":"Cd","form":"Dd","label":"Ed","asterisk":"Fd","smallprint":"Gd","success":"Hd","circle":"Id"};